import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { LogoFull } from "./Logo";
import { useStore } from "@/context/StoreContext";

const LINKS = [
  { label: "Abonnement", href: "#abonnement" },
  { label: "Kontakt", href: "#kontakt" },
];

export const Nav = () => {
  const { user, openOrder, logout } = useStore();

  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-nav"
      className="fixed top-0 inset-x-0 z-50 bg-slate-100/95 backdrop-blur-xl border-b border-white shadow-[0_1px_24px_rgba(0,0,0,0.35)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-[64px] sm:h-[76px] flex items-center justify-between gap-2">
        <Link to="/" data-testid="nav-logo" aria-label="Apexa Link hjem" className="shrink-0">
          <LogoFull size={38} />
        </Link>

        <nav className="flex items-center gap-2.5 sm:gap-6" data-testid="nav-items">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="hidden sm:inline text-xs sm:text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </a>
          ))}
          {user?.role === "admin" && (
            <>
              <Link
                to="/admin"
                data-testid="nav-admin-link"
                className="text-xs sm:text-sm text-[#FF4800] hover:text-orange-600 transition-colors"
              >
                Admin
              </Link>
              <button
                onClick={logout}
                data-testid="nav-logout-button"
                aria-label="Logg ut"
                className="p-1.5 text-slate-500 hover:text-orange-600 transition-colors"
              >
                <LogOut size={15} />
              </button>
            </>
          )}
          <a
            href="https://map.apexa.link"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-map-link"
            className="font-display font-bold text-xs sm:text-sm bg-cyan-400 hover:bg-cyan-300 text-[#06090E] px-3.5 sm:px-6 py-2 sm:py-2.5 rounded-full transition-all duration-300 hover:shadow-[0_0_28px_rgba(0,229,255,0.45)] hover:-translate-y-0.5 whitespace-nowrap"
          >
            Sporing
          </a>
          <button
            onClick={() => openOrder()}
            data-testid="nav-order-button"
            className="font-display font-bold text-xs sm:text-sm bg-[#FF4800] hover:bg-[#ff5d1f] text-white px-3.5 sm:px-6 py-2 sm:py-2.5 rounded-full transition-all duration-300 hover:shadow-[0_0_28px_rgba(255,72,0,0.45)] hover:-translate-y-0.5 whitespace-nowrap"
          >
            Bestill nå
          </button>
        </nav>
      </div>
    </header>
  );
};
